import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const CLU_ZLOG_SCHEMA_LITERAL = {
    title: 'Schéma LOG',
    description: 'LOG',
    version: 0,
    keyCompression: false,
    primaryKey: 'LOG_GID',
    type: 'object',
    properties: {
        LOG_GID : { type : 'string', maxLength : 50 },
        LOG_DATEEVENT : { type : 'string' }, 
        LOG_EVT_CODE : { type : 'string' }, 
        LOG_EVT_TARGET : { type : ['string', 'null'] }, 
        LOG_EVT_LIB : { type : 'string' }, 
        LOG_EVT_DATA : { type : 'string' }, 
        USER_GID : { type : 'string' }, 
        MD_SITEGID : { type : 'string' },
        MD_SITE_LIB : { type : 'string' },
        MD_CAISSE : { type : 'string' },
        MD_CAISSE_LIB : { type : 'string' },
        MD_CAISSIERGID : { type : 'string' },
        MD_CAISSIER_LIB : { type : 'string' },
        MD_CAISSE_SESSION : { type : 'string' },
        MD_SITE_SESSION : { type : 'string' },
        MD_LOCALGID : { type : 'string' },
        ZSYNCUP_FLAG  : { type : 'number', default : 0 },
        ZSYNCUP_STATUS  : { type : 'string' },
        ZSYNCUP_ERROR_MESSAGE  : { type : 'string' },
        ZSYNCUP_DATETIME  : { type : 'string' },
        ZSYNCUP_FEEDID  : { type : 'string' }
    },
    required: [ 'LOG_GID' ]
} as const;

const schemaTyped = toTypedRxJsonSchema(CLU_ZLOG_SCHEMA_LITERAL);
export type RxCluZLogDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const CLU_ZLOG_SCHEMA: RxJsonSchema<RxCluZLogDocumentType> = CLU_ZLOG_SCHEMA_LITERAL;
